import {PropertyDefinitionConfig} from '../types';

// TODO: We pretend that such a repository exists so that we can reuse some existing UI components that were designed for dynamic data structure (e.g. during delete record confirmation we use singular value on Collection to generate dialog title) 
export const REFERENCE_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idReferenceRepository',
	singular: 'Reference', // only this is used
};
